module.exports = __webpack_public_path__ + "static/media/image_placeholder.67256b49.png";